import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { Observable } from 'rxjs';
import { SpecialFreightOverviewModel } from '../../models';
import { ShipmentSpecialFreightManagerEndpoint } from '../../constants';
import { getQueryStringFromObject } from '../../../../../common';
import { SpecialFreightIdView } from '../../../../models';

@Injectable({ providedIn: 'root' })
export class ShipmentSpecialFreightMainInfoService {
  constructor(private http: WrapperHttpService) {}

  getOverviewData(identifier: SpecialFreightIdView): Observable<SpecialFreightOverviewModel> {
    const url = `${API_URL}${ShipmentSpecialFreightManagerEndpoint.Base}${
      ShipmentSpecialFreightManagerEndpoint.SpecialFreights
    }${ShipmentSpecialFreightManagerEndpoint.Summary}?${getQueryStringFromObject(identifier)}`;

    return this.http.withLoading().get(url);
  }
}
